import { httpClient } from '@/services/http/httpClient'

type Tag = {
  id: string
  name: string
  color: string
  textColor: string
}

type GetTagsResponse = {
  tags: Tag[]
}

export async function getTags(portfolioId: string): Promise<GetTagsResponse> {
  const { data } = await httpClient.get<GetTagsResponse>(
    `/projects/portfolio-tags/${portfolioId}`,
  )

  return data
}
